import script from "./CardBrandsMark.vue?vue&type=script&setup=true&lang=js"
export * from "./CardBrandsMark.vue?vue&type=script&setup=true&lang=js"

import "./CardBrandsMark.vue?vue&type=style&index=0&id=46f930fa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46f930fa"]])

export default __exports__